import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import LeagueStandings from "../Leagues/components/Standings";

import { store } from "../..";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { ILeague } from "../../types/api";

export const loader = async ({ params }: any) => {
    const leagues = store.getState().leaguemanagement.leagues;

    !leagues.length &&
        (await store.dispatch(leagueManagementActions.getLeagues()));

    const league = store.getState().leaguemanagement.selectedLeague;

    let selectedLeague: ILeague | undefined;

    if (!league) {
        store.dispatch(
            leagueManagementActions.setSelectedLeague(
                parseInt(params.leagueId),
            ),
        );
        selectedLeague = selectSelectedLeague(store.getState());
    } else {
        selectedLeague = selectSelectedLeague(store.getState());
    }

    const header = `${selectedLeague?.ageLevel}${selectedLeague?.designation ? ` ${selectedLeague.designation}` : ""}${selectedLeague?.direction ? ` ${selectedLeague.direction}` : ``} Standings`;

    return {
        header,
    };
};

const LeagueManagementLeagueStandings = (): React.JSX.Element => {
    const league = useAppSelector(selectSelectedLeague) as ILeague;

    return (
        <div data-testid="leagueContent">
            <Container className="league py-2 py-lg-0" fluid="xs">
                <Row>
                    <Col>
                        <LeagueStandings
                            data={league}
                            expanded
                            bordered
                            showLinks={false}
                        />
                        ;
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LeagueManagementLeagueStandings;
